import React from 'react';
import Reflux from 'reflux';
import ResizingTextareaStore from 'flux/stores/cuesheet/ResizingTextareaStore';
import RTE from 'shared/components/rte/rte.jsx';
import Popover from 'shared/components/misc/popover';
import classnames from 'classnames';

/**
 * Popover with embedded RTE Editor
 */
export default React.createClass({
  mixins: [
    Reflux.connectFilter(ResizingTextareaStore, 'height', (st) =>
      st.get('height'),
    ),
  ],

  propTypes: {
    id: React.PropTypes.string,
    minHeight: React.PropTypes.number,
    editorClassName: React.PropTypes.string,
    toolbarClassName: React.PropTypes.string,
    displayNode: React.PropTypes.object,
    onContentChange: React.PropTypes.func,
    toolbarOnFocus: React.PropTypes.bool,
  },

  render() {
    const { id, displayNode, editorClassName, minHeight, rowId } = this.props;

    const height =
      minHeight > this.state.height ? minHeight : this.state.height;

    let compactClassName =
      window.location.href.indexOf('/compact') >= 0 ||
      window.location.href.indexOf('/featured') >= 0 ||
      window.location.href.indexOf('/global') >= 0
        ? 'compact-cuesheet'
        : null;

    return (
      <Popover
        display
        displayNode={displayNode}
        popoverId={id}
        classes={classnames('rte-popover', editorClassName, compactClassName)}
      >
        <RTE displayToolbar height={height} {...this.props} rowId={rowId} />
      </Popover>
    );
  },
});
